import * as React from 'react'
import { useRifm } from 'rifm'

import { cn } from '../../lib/utils'
import { Input } from '../ui'

const formatIban = (str: string) => {
  return str
    .replace(/\s/g, '')
    .replace(/(.{4})/g, '$1 ')
    .trim()
}

export interface IBANInputProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'onChange' | 'value'
  > {
  onChange: (value: string) => void
  value: string
}

export const IBANInput = React.forwardRef<HTMLInputElement, IBANInputProps>(
  ({ className, onChange, value, ...props }, ref) => {
    const rifm = useRifm({
      value,
      onChange,
      format: formatIban,
      accept: /[A-Z0-9]/gi,
    })

    return (
      <Input
        className={cn('uppercase', className)}
        ref={ref}
        value={rifm.value}
        onChange={rifm.onChange}
        maxLength={34}
        {...props}
      />
    )
  },
)

IBANInput.displayName = 'IBANInput'
